// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"22b93aed","302":"02946f8d","445":"7745d3f5","974":"4145092e"}[chunkId] + ".chunk.js";
};